import Lightbox from './react-image-lightbox.js';

export default Lightbox;
